// extracted by mini-css-extract-plugin
module.exports = {"input":"ChatInputBox_input__9yXGg","section":"ChatInputBox_section__j61a7"};